import * as React from 'react';
import { Icon } from '../../../Images';
import { ConfigurationModel, GroupModel } from 'franke-trough-dependencies';
import { Link } from 'react-router-dom';
import './FolderListItem.scss';
import FolderListItemDetail from './ListItemDetail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, FormattedDate } from 'react-intl';
import MESSAGES from './FolderListItem.messages';
import { formatMessage, GlobalPrivateState } from 'src/api';
import { createApiUrl, appSettings } from 'src/config';
import { userIsInternal } from 'src/app/Partials/Admin/utils';
import ConfigurationNewFolder from '../../SwitchView/ConfigurationNewFolder';
import ConfigurationEditFolder from '../../SwitchView/ConfigurationEditFolder';
import ConfigurationDeleteFolder from '../../SwitchView/ConfigurationDeleteFolder';

export interface FolderListItemProps {
  group: GroupModel;
  user: GlobalPrivateState['user'];
  userData: GlobalPrivateState['userData'];
  onShowSettings?: (id?: string) => void;
  isNested?: boolean;
}

export interface FolderListItemState {
  showSettings: boolean;
  isEditing: boolean;
  isDeleting: boolean;
}

export class FolderListItem extends React.Component<FolderListItemProps, FolderListItemState> {
  private toggleRef: React.RefObject<HTMLDivElement>;

  constructor(props: FolderListItemProps) {
    super(props);
    this.toggleRef = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.state = {
      showSettings: false,
      isEditing: false,
      isDeleting: false
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  private handleOutsideClick(event: MouseEvent) {
    if (this.toggleRef.current && !this.toggleRef.current.contains(event.target as Node)) {
      this.setState({ showSettings: false });
    }
  }

  public render() {
    const { group, isNested, user, userData } = this.props;
    const { showSettings } = this.state;

    return (
      <>
        <div className={`partial-folder-list-item ${showSettings ? 'show-settings' : ''}`}>
          <Link to={`/folders/${group.id}`} className="folder folder-configuration h-100 d-flex">
            <Icon name="folder" size="small" />
            <div className="folder-details">
              <div className="folder-label">
                <div className="folder-name" title={group.name}>{group.name}</div>
                <div className="folder-count" title={group.name}>({group.count || 0})</div>
              </div>
              <div className="folder-date">
                {group.metavalue && (
                  <> 
                    {!isNested ? 'BN' : 'ON'}:{' '}
                    {group.metavalue}
                    {' '}&nbsp;|&nbsp;{' '}
                  </>
                )}
                <FormattedDate
                  value={group.created_at}
                  day="2-digit"
                  month="2-digit"
                  year="numeric"
                />
              </div>
            </div>
          </Link>
          <div className="dropdown-wrapper" ref={this.toggleRef} onClick={this.handleClick}>
            <div>
              <Icon name="menu-dots" size="small" />
            </div>
            {showSettings && (
              <div className="dropdown-list">
                <ul>
                  <li onClick={() => {this.setState({isEditing: true});}}>
                    <Icon name="rename" size="small" />
                    {isNested ? (
                      <FormattedMessage {...MESSAGES.folderListItemNestedRename} />
                    ) : (
                      <FormattedMessage {...MESSAGES.folderListItemRename} />
                    )}
                  </li>
                  <li onClick={() => {this.setState({isDeleting: true});}}>
                    <Icon name="delete" size="small" />
                    {isNested ? (
                      <FormattedMessage {...MESSAGES.folderListItemNestedDelete} />
                    ) : (
                      <FormattedMessage {...MESSAGES.folderListItemDelete} />
                    )}
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        {this.state.isEditing && (
          <ConfigurationEditFolder
            folderId={group.id}
            folderName={group.name}
            metavalue={group.metavalue}
            isNested={isNested}
            drilledClose={() => {
              this.setState({isEditing: false});
            }}
            drilledConfirm={async () => {
              this.setState({isEditing: false});
            }}
          />
        )}

        {this.state.isDeleting && (
          <ConfigurationDeleteFolder
            folderId={group.id}
            drilledClose={() => {
              this.setState({isDeleting: false});
            }}
            drilledConfirm={async () => {
              this.setState({isDeleting: false});
            }}
          />
        )}
      </>
    );
  }

  private handleClick(event: React.MouseEvent) {
    event.preventDefault();
    this.setState((prevState) => ({
      showSettings: !prevState.showSettings,
    }));
  }
}

export default FolderListItem;